<template>
  <div v-if="loading" class="loading" :style="{top:top+'px',bottom:bottom+'px'}">
    <van-loading type="spinner" />
  </div>
</template>
  
<script>
export default {
  name: 'Index',
  //import 引入组件
  props:{
    loading:{
      type:Boolean,
      default:true
    },
    top:{
      type:Number,
      default:50
    },
    bottom:{
      type:Number,
      default:0
    }
  },
  setup(){
    return{
    }
  }
}
</script>
  
<style scoped>
.loading {
  position: fixed;
  z-index: 10001;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>